import { Outlet } from 'react-router-dom'
import { AuthSuper } from 'app/components/auth/AuthSuper'
import { AgentsLayoutShadcnComponent } from 'app/components/agents-layout/AgentsLayoutShadcnComponent'

export default function AgentsLayout() {
  return (
    <AuthSuper>
      <AgentsLayoutShadcnComponent>
        <Outlet />
      </AgentsLayoutShadcnComponent>
    </AuthSuper>
  )
}
